import { render, staticRenderFns } from "./ModalContactPhone.vue?vue&type=template&id=1547d9c1&scoped=true&"
import script from "./ModalContactPhone.vue?vue&type=script&lang=js&"
export * from "./ModalContactPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1547d9c1",
  null
  
)

export default component.exports